module.exports = __webpack_public_path__ + "img/favorite-icon.6ac1cd29.svg";